export default __webpack_public_path__ + "static/media/Qr_code.07e466bf.svg";